<template>
  <v-row>
    <v-col cols="12" sm="6" md="4">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateInput"
            :label="label + ' Date'"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateInput"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="11" sm="5">
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="timeInput"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="timeInput"
            :label="label + ' Time'"
            prepend-icon="mdi-clock-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="menu2"
          v-model="timeInput"
          full-width
          @click:minute="$refs.menu.save(timeInput)"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>
<script>
import moment from 'moment'
export default {
  props: ['datetime', 'label'],
  data() {
    return {
      menu1: false,
      menu2: false
    }
  },
  computed: {
    dateInput: {
      get: function() {
        // split into separate date field
        return moment(this.datetime).format('YYYY-MM-DD')
      },
      set: function(val) {
        // set to ISO and emit
        this.$emit('input', moment(val + ' ' + this.timeInput).format())
      }
    },
    timeInput: {
      get: function() {
        // split into separate time field
        return moment(this.datetime).format('HH:mm')
      },
      set: function(val) {
        // set to ISO and emit
        this.$emit('input', moment(this.dateInput + ' ' + val).format())
      }
    }
  }
}
</script>
